<!--Modals-->
<app-common-bulk-select-employee-dialog #appEmployeeSelection [label]="'time-off-v3.assign' | translate">
</app-common-bulk-select-employee-dialog>
<ui-card [loading]="isLoading">
    <app-segment-header title="time-off-v3.policyComponents.enrolled-employees.header">
        <div class="buttons" *ngIf="!workSchedule.isDefault">
            <ui-button type="link" (click)="showAssignDialog()"> {{ 'edit' | translate }} </ui-button>
        </div>
    </app-segment-header>

    <div class="margin-bottom-3">
        <app-search #searchBar placeholder="search" (onSearch)="onSearch($event)"></app-search>
    </div>
    <app-simple-table
        *ngIf="rows.length; else empty"
        [attr.data-cy]="'enrolledEmployeesTable'"
        [columns]="columns"
        [rows]="rows"
        [fixedHeight]="true"
    ></app-simple-table>

    <!-- Empty State -->
    <ng-template #empty>
        <app-empty-state
            [class.hidden]="isLoading"
            label="time-off-v3.policyComponents.enrolled-employees.noResults"
            src="/assets/illustrations/chair.png"
        ></app-empty-state>
    </ng-template>
</ui-card>
